import React, { useMemo, useState } from "react";
import { useEventContext, useUserContext } from "../../../../context";
import cloneDeep from "lodash.clonedeep";
import { Button, DropdownButton, MenuItem, } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import FieldsListModal from "./FieldsListModal";
import AuthField from "./AuthField";
import Loading from "../../../Loading";
import { updateEventModuleAuthFields } from "../../../../../api/cp/eventModuleAuth";

export default ({ moduleAuth, defaultDisclaimers, handleAddDisclaimers, authFields, setAuthFields, handleAddField, handleSaveField, handleDeleteField, registrationFields = [], setRegistrationFields }) => {
    const { event } = useEventContext();
    const { userIsSuperAdmin } = useUserContext();

    const [isSaving, setSaving] = useState(false);
    const [showFieldsListModal, setShowFieldsListModal] = useState(false);

    const hasPersonalData = useMemo(() =>
        moduleAuth.email || moduleAuth.phone ||
        registrationFields.filter(field => !defaultDisclaimers.includes(field.field.name)).length,
        [moduleAuth, registrationFields])

    const handleDragEnd = async (result) => {
        if (!result.destination) {
            return;
        }

        let _registrationFields = cloneDeep(registrationFields);
        const _registrationFieldsCopy = cloneDeep(registrationFields);
        const [removed] = _registrationFields.splice(result.source.index, 1);
        _registrationFields.splice(result.destination.index, 0, removed);
        _registrationFields = _registrationFields.map((field, idx) => ({ ...field, order: idx + 1 }));

        const updatedFields = _registrationFields
            .filter(_rField => registrationFields.find(({ id }) => id === _rField.id)?.order !== _rField.order)

        setRegistrationFields(_registrationFields);
        setSaving(true);

        try {
            await updateEventModuleAuthFields(event.eventKey, updatedFields);
        } catch (e) {
            console.error(e);
            setRegistrationFields(_registrationFieldsCopy);
        } finally {
            setSaving(false);
        }
    }

    const handleAddRegistrationField = async (field) => {
        await handleAddField(field);
        if (!defaultDisclaimers.includes(field.name)) {
            handleAddDisclaimers();
        }
    }

    const checkDeletable = (field) => {
        if (field.field.name === 'phone') {
            return !moduleAuth.phone;
        }
        if (defaultDisclaimers.includes(field.field.name)) {
            return !hasPersonalData || userIsSuperAdmin;
        }
        return true;
    }

    const availableFields = authFields.filter(field => !registrationFields.map(({ fieldId }) => fieldId).includes(field.id));

    return <div style={{ position: 'realtive' }}>
        <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <DropdownButton title="Добавить поле" id="addAuthField" disabled={!availableFields.length || isSaving}>
                {availableFields.map(field => (<MenuItem
                    key={field.id}
                    onClick={() => handleAddRegistrationField(field)}
                >
                    {field.label_ru}
                </MenuItem>
                ))}
            </DropdownButton>
            <Button onClick={() => setShowFieldsListModal(true)}>Список полей</Button>
        </div>
        <div>
            {(moduleAuth.email || moduleAuth.phone) && <AuthField id={'email'} title={'Email'} required disabledTotal />}
            <AuthField id={'name'} title={'Имя'} required disabledTotal />
            <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {registrationFields.sort((a, b) => a.order - b.order).map((field, index) => (
                                <Draggable
                                    key={field.field.id}
                                    draggableId={`${field.field.id || index}`}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{
                                                ...provided.draggableProps.style,
                                            }}
                                        >
                                            <AuthField
                                                id={field.field.id}
                                                title={field.field.label_ru}
                                                required={field.required}
                                                disabled={!checkDeletable(field)}
                                                handleUpdateField={(data) => handleSaveField(field.field.id, data)}
                                                handleDeleteField={() => handleDeleteField(field.field.id)}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </div>
        {isSaving && <LoaderFields />}
        <FieldsListModal show={showFieldsListModal} defaultDisclaimers={defaultDisclaimers} onHide={() => setShowFieldsListModal(false)} fields={authFields} setFields={setAuthFields} />
    </div>
}

const LoaderFields = () => {
    return <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(255, 255, 255, 0.4)'
    }}>
        <Loading>
            <>{' '}</>
        </Loading>
    </div>
}